import { getCookie } from 'lib/cookie'
import { ISmartAlertMarketplaceDocument } from 'services/Home/widgets/SmartAlert/interface'
import stores from 'stores/index'

function sellerFilter(
  alert: ISmartAlertMarketplaceDocument,
  page: string,
): boolean {
  const currentTime = new Date().getTime()
  const cookieName = `${page}-${alert.alert_key}`
  const startDate = alert.configuration.start_date
  const endDate = alert.configuration.end_date
  const {
    isGetStoreListCalled,
    firstStore,
  } = stores.getState().storeSeller

  /**
   * GUARD: is user login
   */
  if (!getCookie('access_token')) {
    return false
  }

  /**
   * GUARD: user do not have store
   */
  if (isGetStoreListCalled && !firstStore) {
    return false
  }

  return (
    firstStore &&
    alert.is_active &&
    currentTime >= startDate.seconds * 1000 &&
    currentTime <= endDate.seconds * 1000 &&
    currentTime >= Number(getCookie(cookieName) ?? 0)
  )
}

export default sellerFilter
